/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  events Definitions
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { JSONManager, globalEngine, ModuleManager } from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function getEventConfiguration() {
    var events = {};
    try {
        events = JSONManager.create("events");
    }
    catch (e) {
        logError("ERROR: Could not load events.json " + e.message);
    }
    return events;
}

ModuleManager.registerFactory("event_config", getEventConfiguration);
//export {getEventConfiguration};
//globalEngine.FactoryMap["event_config"] =  getEventConfiguration;
